import { Box, Typography } from '@mui/material';

import useReferenceData from '@acorn-portal/shared/src/hooks/useReferenceData';
import { VehicleDetails2 } from '@acorn-portal/shared/src/services/api';
import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { ListNames } from '@acorn-portal/shared/src/store/referenceData.slice';
import { FC, ReactNode } from 'react';
import { getVehicleIconByProduct } from '../../utils/constants/vehicleIcons';

interface VehicleDetails extends VehicleDetails2 {
	annualMileage?: number;
	licencingAuthority?: string;
}

interface IVehicle {
	vehicle: VehicleDetails;
	product: Product;
	children?: ReactNode;
	isSummaryScreen?: boolean;
}

const Vehicle: FC<IVehicle> = ({ vehicle, children, product, isSummaryScreen = false }) => {
	const { getReferenceDataValue } = useReferenceData();
	const icon = getVehicleIconByProduct(product);

	return (
		<Box>
			<Box sx={{ display: 'flex' }}>
				<Box sx={{ width: '65px', marginRight: '3em' }}>{icon}</Box>
				<Box>
					<Typography
						sx={{
							fontSize: 20,
							fontWeight: 'bold',
							textTransform: 'uppercase',
						}}
					>
						{vehicle.registrationNumber}
					</Typography>
					<Typography>
						{vehicle.make}, {vehicle.model}
					</Typography>

					{vehicle.vehicleUse && (
						<Box sx={{ my: 1 }}>
							<Typography fontWeight='bold'>Vehicle Usage</Typography>
							<Typography data-testid='vehicle-usage'>
								{getReferenceDataValue(ListNames.vehicleUseOptions, vehicle.vehicleUse)}
							</Typography>
						</Box>
					)}
					{product === Product.TAXI && vehicle.licencingAuthority && !isSummaryScreen && (
						<>
							<Typography sx={{ fontWeight: 'bold' }}>Licensing Authority</Typography>
							<Typography>
								<Typography>{getReferenceDataValue(ListNames.licencingArea, vehicle.licencingAuthority)}</Typography>
							</Typography>
						</>
					)}
					{[Product.TELEMATICS, Product.CARROT].includes(product) && (
						<Box sx={{ my: 1 }}>
							<Typography fontWeight='bold'>Annual Mileage</Typography>
							<Box>
								<Typography>{vehicle.annualMileage}</Typography>
							</Box>
						</Box>
					)}
					{children}
				</Box>
			</Box>
		</Box>
	);
};

export default Vehicle;
